var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataOverwrite01 = function SvgDataOverwrite01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "data_overwrite-01_svg2__a",
    x1: -7.48,
    x2: 178.87,
    y1: 184.24,
    y2: 28.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__b",
    x1: 41.25,
    x2: 227.6,
    y1: 242.51,
    y2: 86.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__c",
    x1: -1.93,
    x2: 184.43,
    y1: 190.89,
    y2: 35.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__d",
    x1: -90.05,
    x2: 96.3,
    y1: 85.52,
    y2: -70.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__e",
    x1: -72.09,
    x2: 114.26,
    y1: 106.99,
    y2: -48.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__f",
    x1: -81.07,
    x2: 105.28,
    y1: 96.26,
    y2: -59.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__g",
    x1: -63.13,
    x2: 123.22,
    y1: 117.71,
    y2: -38.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__h",
    x1: -54.15,
    x2: 132.2,
    y1: 128.44,
    y2: -27.42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__i",
    x1: -21.95,
    x2: 164.4,
    y1: 166.94,
    y2: 11.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__j",
    x1: -32.69,
    x2: 153.67,
    y1: 154.11,
    y2: -1.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__k",
    x1: -43.42,
    x2: 142.93,
    y1: 141.27,
    y2: -14.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__l",
    x1: -11.24,
    x2: 175.12,
    y1: 179.75,
    y2: 23.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__m",
    x1: -20.22,
    x2: 166.14,
    y1: 169.02,
    y2: 13.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__n",
    x1: -29.18,
    x2: 157.18,
    y1: 158.31,
    y2: 2.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__o",
    x1: -38.15,
    x2: 148.2,
    y1: 147.57,
    y2: -8.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__p",
    x1: -47.13,
    x2: 139.22,
    y1: 136.84,
    y2: -19.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__q",
    x1: -57.84,
    x2: 128.51,
    y1: 124.03,
    y2: -31.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__r",
    x1: -68.58,
    x2: 117.77,
    y1: 111.19,
    y2: -44.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_overwrite-01_svg2__a",
    id: "data_overwrite-01_svg2__s",
    x1: -79.31,
    x2: 107.04,
    y1: 98.36,
    y2: -57.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M160.44 15.1h-24.42l6.02-6.02a5.31 5.31 0 0 0 0-7.52 5.31 5.31 0 0 0-7.52 0l-15.04 15.09c-1.02 1.02-1.55 2.35-1.55 3.76s.58 2.74 1.55 3.76l15.09 15.09c1.02 1.02 2.39 1.55 3.76 1.55s2.7-.53 3.76-1.55a5.31 5.31 0 0 0 0-7.52l-6.02-6.02h24.42c15.88 0 28.76 12.92 28.76 28.76v17.83c0 2.92 2.39 5.31 5.31 5.31s5.31-2.39 5.31-5.31V54.48c0-21.72-17.7-39.38-39.42-39.38Z",
    style: {
      fill: "url(#data_overwrite-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.15 102.17h-87.21c-2.92 0-5.31 2.39-5.31 5.31v87.21c0 2.92 2.39 5.31 5.31 5.31h87.21c2.92 0 5.31-2.39 5.31-5.31v-87.21a5.3 5.3 0 0 0-5.31-5.31m-5.31 87.21h-76.59v-76.59h76.59z",
    style: {
      fill: "url(#data_overwrite-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.44 160.75c-2.08-2.08-5.44-2.08-7.52 0s-2.08 5.44 0 7.52l6.02 6.02H39.52c-15.88 0-28.76-12.92-28.76-28.76V127.7c0-2.92-2.39-5.31-5.31-5.31S.14 124.78.14 127.7v17.83c0 21.72 17.65 39.38 39.38 39.38h24.42l-6.02 6.02a5.311 5.311 0 0 0 3.76 9.07c1.37 0 2.7-.53 3.76-1.55l15.09-15.09a5.31 5.31 0 0 0 0-7.52z",
    style: {
      fill: "url(#data_overwrite-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85 10.63c1.42 0 2.79-.58 3.76-1.55s1.55-2.35 1.55-3.76-.58-2.79-1.55-3.76S7.26.01 5.85.01 3.06.59 2.09 1.56.54 3.91.54 5.32s.58 2.79 1.55 3.76c1.02.97 2.35 1.55 3.76 1.55",
    style: {
      fill: "url(#data_overwrite-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.47 10.63c2.92 0 5.31-2.39 5.31-5.31S52.39.01 49.47.01s-5.31 2.39-5.31 5.31 2.35 5.31 5.31 5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.66 10.63c2.92 0 5.31-2.39 5.31-5.31S30.58.01 27.66.01s-5.31 2.39-5.31 5.31 2.39 5.31 5.31 5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.24 10.63c2.92 0 5.31-2.39 5.31-5.31S74.16.01 71.24.01s-5.31 2.39-5.31 5.31 2.39 5.31 5.31 5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05.01c-1.37 0-2.79.58-3.76 1.55s-1.55 2.35-1.55 3.76.58 2.79 1.55 3.76 2.35 1.55 3.76 1.55 2.79-.58 3.76-1.55 1.55-2.35 1.55-3.76-.58-2.79-1.55-3.76S94.47.01 93.05.01",
    style: {
      fill: "url(#data_overwrite-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05 65.45c-2.92 0-5.31 2.39-5.31 5.31s2.39 5.31 5.31 5.31 5.31-2.39 5.31-5.31-2.35-5.31-5.31-5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05 43.64c-2.92 0-5.31 2.39-5.31 5.31s2.39 5.31 5.31 5.31 5.31-2.39 5.31-5.31-2.35-5.31-5.31-5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05 21.82c-2.92 0-5.31 2.39-5.31 5.31s2.39 5.31 5.31 5.31 5.31-2.39 5.31-5.31-2.35-5.31-5.31-5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05 87.22c-1.42 0-2.79.58-3.76 1.55s-1.55 2.35-1.55 3.76.58 2.79 1.55 3.76 2.35 1.55 3.76 1.55 2.79-.58 3.76-1.55 1.55-2.35 1.55-3.76-.58-2.79-1.55-3.76a5.38 5.38 0 0 0-3.76-1.55",
    style: {
      fill: "url(#data_overwrite-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.24 97.84c2.92 0 5.31-2.39 5.31-5.31s-2.39-5.31-5.31-5.31-5.31 2.39-5.31 5.31 2.39 5.31 5.31 5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.47 97.84c2.92 0 5.31-2.39 5.31-5.31s-2.39-5.31-5.31-5.31-5.31 2.39-5.31 5.31 2.35 5.31 5.31 5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.66 97.84c2.92 0 5.31-2.39 5.31-5.31s-2.39-5.31-5.31-5.31-5.31 2.39-5.31 5.31 2.39 5.31 5.31 5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85 97.84c1.42 0 2.79-.58 3.76-1.55s1.55-2.35 1.55-3.76-.58-2.79-1.55-3.76-2.35-1.55-3.76-1.55-2.79.58-3.76 1.55S.54 91.12.54 92.53s.58 2.79 1.55 3.76c1.02.97 2.35 1.55 3.76 1.55",
    style: {
      fill: "url(#data_overwrite-01_svg2__p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85 76.07c2.92 0 5.31-2.39 5.31-5.31s-2.39-5.31-5.31-5.31S.54 67.84.54 70.76s2.39 5.31 5.31 5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85 54.26c2.92 0 5.31-2.39 5.31-5.31s-2.39-5.31-5.31-5.31S.54 46.03.54 48.95s2.39 5.31 5.31 5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85 32.44c2.92 0 5.31-2.39 5.31-5.31s-2.39-5.31-5.31-5.31S.54 24.21.54 27.13s2.39 5.31 5.31 5.31",
    style: {
      fill: "url(#data_overwrite-01_svg2__s)"
    }
  }));
};
export default SvgDataOverwrite01;